<template>


        <div class="form" >
          <v-card style="margin-top: 250px">
              <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <h1 align="center" style="text-decoration: underline overline;">Maklumat Isi Rumah (JRA)</h1>
      
            <v-text-field
              outlined 
              dense
              rounded
              v-model="HID"
              label="HID"
              width="20px"
              disabled
            ></v-text-field>
          
    
            <!-- DATATABLE  -->
              <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
                    <v-card-title>
                        Senarai
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                      :headers="headers"
                      :items="dataJRA"
                      :search="search"
                      class="ml-3 mr-3"
                      @click:row="handleClick"
                      :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
                    ></v-data-table>
              </v-card>   
        </v-card>
  
  
   
  <v-card><br>&nbsp;&nbsp;&nbsp;&nbsp;
      <span style="color:red;font-weight:bold;font-size: small;"> Medan yang bertanda * wajib diisi</span>
    <v-card-title>
      JR4 - JRA Maklumat Isi Rumah
    </v-card-title>
  
    <v-card-text>
        <!-- S1 -->
          <v-row>
            <v-col class="black--text">
            S1 : Nama <strong>[NAMA]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                  v-model="Nama"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          
          <!-- S2 -->
          <v-row>
            <v-col class="black--text">
            S2 : Perhubungan Dengan Ketua Isi Rumah <strong>[PKIR]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                  v-model="PKIR"
                  outlined
                  dense
                  disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
  
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
      
  
          <!-- S3,S4,S4a -->
          <v-row>
            <v-col class="black--text">
             S3 : Kewarganegaraan <strong>[KW]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="kewarganegaraan"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih Kewarganegaraan.."
              return-object
              outlined
              dense
              v-model="KW"
              ></v-autocomplete>
            </v-col>

            <v-col class="black--text" v-show="showS7">
              S4 : Kad Pengenalan <strong>[NOIC]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field              
              :maxlength="12"
              v-model="NOIC"
                  outlined
                  dense
              ></v-text-field>
            </v-col>

            <v-col class="black--text" v-show="showS8">
             S5 : Residen <strong>[RES]</strong>
              <v-autocomplete
              :items="residen"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih residen.."
              return-object
              outlined
              dense
              v-model="RS"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="black--text">
            S6 : Jantina <strong>[J]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
             <v-autocomplete
              :items="Jantina"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih jantina.."
              return-object
              outlined
              dense
              v-model="J"
            ></v-autocomplete>
            </v-col>
  
            <v-col class="black--text">
            S7 : Tahun Kelahiran <strong>[TK]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
             <v-text-field
             v-model="TK"
             type="number" :min="1926"   max="2030"   
                  outlined
                  dense
              ></v-text-field>
            </v-col>
  
            <v-col class="black--text">
            S7a : Umur <strong>[U]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>           
            <v-text-field
                  v-model="U"
                  outlined
                  dense
                  disabled
              ></v-text-field>
            </v-col>

            <v-col class="black--text">
            S7b : Bulan <strong>[BTK]</strong>        
            <v-text-field
                  v-model="BTK"
                  outlined
                  dense
                  type="number"
              ></v-text-field>
            </v-col>
          </v-row>


          <!-- S5,S6 -->
          <v-row>
            <v-col class="black--text">
             S8 : Kumpulan Etnik <strong>[KET]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="kumpulanEtnik"
              :item-text="item => item.kodEtnik +' - '+ item.namaEtnik"
              label="Sila pilih Etnik.."
              return-object
              outlined
              dense
              v-model="KET"
              ></v-autocomplete>
            </v-col>

            <v-col class="black--text">
             S9 : Taraf Perkahwinan <strong>[TP]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="tarafPerkahwinan"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih taraf perkahwinan.."
              return-object
              outlined
              dense
              v-model="TP"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="black--text">
             S10 : Jenis Ketidakupayaan <strong>[OKU]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="jenisKetidakupayaan"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih jenis ketidakupayaan.."
              return-object
              outlined
              dense
              v-model="OKU"
              ></v-autocomplete>
            </v-col>

       
              <v-col class="black--text" v-show="showS10">
              S10a : Pelbagai <strong>[OKUP]</strong>
              <v-text-field
                label="Sila nyatakan pelbagai.."
                  v-model="OKUP"
                outlined
                dense
                
                ></v-text-field>
              </v-col>

              <v-col class="black--text" v-show="showS11">
             S11 : Pendaftaran OKU <strong>[POKU]</strong>
              <v-autocomplete
              :items="pendaftaranOKU"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih pendaftaran OKU.."
              return-object
              outlined
              dense
              v-model="POKU"
              ></v-autocomplete>
            </v-col>
          </v-row>
  
          <v-row>
            <v-col class="black--text">
             S12 : Persekolahan <strong>[PS]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="persekolahan"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih persekolahan.."
              return-object
              outlined
              dense
              v-model="PS"
              :error-messages="psErrors"
              ></v-autocomplete>
            </v-col>
  
            <v-col class="black--text">
             S13 : Sebab tidak bersekolah <strong>[STS]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="sebabTidakSekolah"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih tidak bersekolah.."
              return-object
              outlined
              dense
              v-model="STS"
              :error-messages="stsErrors"
              ></v-autocomplete>
            </v-col>
          </v-row>
        
          <!-- S14,S15-->
          <v-row>
            <v-col class="black--text">
             S14 : Taraf Pendidikan Tertinggi <strong>[PT]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="tarafPendidikanTertinggi"
              :item-text="item => item.kodPendidikan +' - '+ item.tarafPendidikan"
              label="Sila pilih taraf pendidikan.."
              return-object
              outlined
              dense
              v-model="PT"
              :error-messages="ptErrors"
              ></v-autocomplete>
            </v-col>
  
            <v-col class="black--text">
             S15 : Sijil Tertinggi yang diperoleh di sekolah, maktab atau universiti <strong>[SJ]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="sijilTertinggi"
              :item-text="item => item.kodSijil +' - '+ item.namaSijil"
              label="Sila pilih Sijil tertinggi.."
              return-object
              outlined
              dense
              v-model="SJ"
              :error-messages="sjErrors"
              ></v-autocomplete>
            </v-col>
  
          </v-row>
  
  
          <!-- s16 -->
          <v-row>

              <v-col class="black--text">
                S16 : Apakah taraf aktiviti utama anda/ahli isi rumah dalam 12 bulan yang lepas? <strong>[TA]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-alert-circle
                      </v-icon>
                    </template>
                    <span>1. Tempoh aktiviti paling lama dilakukan dalam tempoh 12 bulan yang lepas; atau</span>
                    <br>
                    <span>2. Pendapatan paling tinggi dalam tempoh 12 bulan yang lepas; atau</span>
                    <br>
                    <span>3. Sekiranya tempoh dan pendapatan aktiviti adalah sama, maka pilihan taraf aktiviti adalah yang semasa</span>
                  </v-tooltip>

                    <v-autocomplete
                    :items="tarafAktiviti"
                    :item-text="item => item.kod_aktiviti +' - '+ item.keterangan"
                    label="Sila pilih taraf aktiviti.."
                    return-object
                    outlined
                    dense
                    v-model="TA"
                    ></v-autocomplete>
              </v-col>
              <v-col class="black--text" v-show="showS16">
                S16a : Lain-lain(nyatakan) <strong>[TA (nyatakan)]</strong>
                <v-text-field
                  label="Sila nyatakan pelbagai.."
                  v-model="TAnyatakan"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
          </v-row>
  
        <!-- PK -->
        <v-row>
          <v-col>
           Apakah jenis pekerjaan utama anda? <strong>[PK]</strong>
          <v-autocomplete
              :items="masco"
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="PK"
          ></v-autocomplete>
          </v-col>
        </v-row>
  
        <!-- PN -->
        <v-row>
          <v-col>
          Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
          <v-autocomplete
              :items='msic'
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="PN"
          ></v-autocomplete>
          </v-col>
        </v-row>
  
         <v-row>
          <v-col>
           Nyatakan tempoh bagi pekerjaan utama anda <strong>[ dalam dua belas bulan (12) yang lalu ][M]</strong>
            <v-row>
              <!-- tempoh -->
              <v-col cols="4">
                <v-autocomplete
                    :items="lookupbulan"
                    v-model="M"
                    label="Tempoh Pengiraan(bulan)"
                    outlined
                    dense
                    return-object
                    :item-text="item => item.id"
                ></v-autocomplete>
              </v-col> 
            
            </v-row>
          </v-col>
        </v-row>
  
          <!-- S17,S18 (perlu jawab sekiranya s16 1 - 7)--> 
          <!-- <v-row>
            <v-col class="black--text" v-show="showS17">
             S17 : Sepanjang 12 bulan yang lepas, bagaimanakah pekerjaan anda/ahli isi rumah terkesan dengan penularan pendemik COVID-19? <strong>[KC]</strong>
              <v-autocomplete
              :items="kesanCovidTerhadapPekerjaan"
              :item-text="item => item.id +' - '+ item.desc"
              label="Sila pilih kesan covid terhadap pekerjaan.."
              return-object
              outlined
              dense
              v-model="KC"
              ></v-autocomplete>
            </v-col> -->
  
  
          <!-- </v-row> -->
  
          <!-- S19,S20--> 
          <!-- * Sekiranya S19 adalah Tidak dan S20 adalah Ya, terus ke modul Penerimaan one-off -->
          <!-- * Sekiranya S19 adalah Ya dan S20 adalah Ya, responden perlu menjawab soalan mengikut turutan -->
          <v-row>
            <v-col class="black--text">
             S19 : Adakah anda/ahli isi rumah menerima sebarang pendapatan (berupa wang tunai/mata benda) daripada sebarang punca dalam 12 bulan yang lepas? <strong>[PP]</strong>
             <span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-alert-circle
                      </v-icon>
                    </template>
                    <span>Penerima pendapatan ditakrifkan sebagai seseorang itu dianggap penerima pendapatan (berupa tunai atau mata benda) dalam tempoh rujukan (sepanjang dua belas bulan yang lepas).</span>
                </v-tooltip>
              
              <v-autocomplete
              :items="yaTidak"
              :item-text="item => item.id +' - '+ item.desc"
              return-object
              outlined
              dense
              v-model="PP"
              ></v-autocomplete>
            </v-col>
  
            <v-col class="black--text" v-show="showS19i">
              S19(i) : Nyatakan bilangan pekerjaan anda/ahli isi rumah
              <span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="lookupS19i"
              :item-text="item => item.id +' - '+ item.desc"
              return-object
              outlined
              dense
              v-model="S19i"
              ></v-autocomplete>
            </v-col>
  
            <v-col class="black--text">
             S20 : Adakah anda/ahli isi rumah menerima sebarang penerimaan one-off dalam 12 bulan yang lepas?
             <span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="yaTidak"
              :item-text="item => item.id +' - '+ item.desc"
              return-object
              outlined
              dense
              v-model="S20"
              ></v-autocomplete>
            </v-col>
  
          </v-row>
  
  
      </v-form>
    </v-card-text>
  
      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                v-show="butangSimpan"
                text
                color="primary"
                @click='simpan()'
                :disabled="checkMandatori()"
            >
              Simpan/Kemaskini
            </v-btn>
            <!-- <v-btn
            v-show="butangSeterusnya"
              text
              color="primary"
              @click="goTo()"
            >
              Seterusnya
            </v-btn> -->
      </v-card-actions>
  </v-card>
  
  
  <!-- Error Dialog -->
  <v-dialog
        v-model="errorDialog"
        width="500"
        height="200"
      >
      <v-card>
        <v-alert
          dense
          outlined
          color="#C51162"
          type="error"
        >
        <strong>{{errMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Success Dialog -->
  <v-dialog
        v-model="successDialog"
        max-width="800"
        height="200"
      >
      <v-card
        color="success"
      >
        <v-alert
          dense
          outlined
          color="#C51162"
          type="success"
        >
        <strong>{{successMessage}}</strong>
        </v-alert>
  
        <v-card-actions> 
          <v-spacer></v-spacer>
              <v-btn
                  color="warning"
                  @click='successDialog = false;goTo("1");'
              >
                Batal
              </v-btn>
              <v-btn
                  color="pink"
                  v-show="butangKemaskini"
                  @click='successDialog = false;'
              >
                Kemaskini
              </v-btn>
              <v-btn
                color="primary"
                @click='goTo("2")'
              >
                Pengisian Seterusnya
              </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
  
  
  </div>
  </template>
  <script>
  import axios from '../../plugins/axios'
  
  /////////////////////////////////////////////////////////
  import getLocalStorage from '@/services/getLocalStorage'
  const localStorageData = new getLocalStorage();
  
  import lookupField from '@/services/lookupField'
  const lookupFieldServices = new lookupField();
  /////////////////////////////////////////////////////////
  export default {
      
      async beforeMount(){
  
          var dataHID = localStorageData.getHIDdata()
  
          this.HID = dataHID.HID;
          this.BNO = dataHID.BNO;
          this.Ps = dataHID.P;
          this.S = dataHID.S;
          this.NG = dataHID.NG;
          this.DP = dataHID.DP;
          this.DB =  dataHID.DB;
          this.BP = dataHID.BP;
          this.ST = dataHID.ST;
          this.NOTK = dataHID.NOTK;
          this.NOIR = dataHID.NOIR;
          this.Bulan = dataHID.BULAN;
          this.Tahun = dataHID.TAHUN;
  
          ///////////////////////////////dapatkan semua lookup table yang diperlukan//////////////////
          this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
          this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
          this.lookupbulan = lookupFieldServices.getBulan();
          this.hubunganIsiRumah = lookupFieldServices.getHubunganDenganKetuaIsiRumah();
          this.Jantina = lookupFieldServices.getJantina();
          this.kumpulanEtnik = await lookupFieldServices.getKumpulanEtnik();
          this.kewarganegaraan = lookupFieldServices.getKewarganegaraan();
          this.residen = lookupFieldServices.getResiden();
          this.tarafPerkahwinan = lookupFieldServices.getTarafPerkahwinan();
          this.jenisKetidakupayaan = lookupFieldServices.getJenisKetidakupayaan();
          this.pendaftaranOKU = lookupFieldServices.getPendaftaranOKU();
          this.persekolahan = lookupFieldServices.getPersekolahan();
          this.sebabTidakSekolah = lookupFieldServices.getSebabTidakBersekolah();
          this.tarafPendidikanTertinggi = await lookupFieldServices.getTarafPendidikan();
          this.sijilTertinggi = await lookupFieldServices.getSijilTertinggi();
          this.tarafAktiviti = await lookupFieldServices.getAktiviti();
          this.kesanCovidTerhadapPekerjaan = lookupFieldServices.getKesanCovidTerhadapPekerjaan();
          this.kesanCovidTerhadapPendapatan = lookupFieldServices.getKesanCovidTerhadapPendapatan();
          this.yaTidak = lookupFieldServices.getYaTidak();
          this.lookupS19i = lookupFieldServices.getS19i();
          this.S19i = this.lookupS19i[0];
          this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
          this.NOAIR = this.currNOAIRData.NOAIR;
          this.Nama = this.currNOAIRData.Nama;
          this.PKIR = this.currNOAIRData.PKIR;
          //this.STS =  this.sebabTidakSekolah[7];
          this.STS =  this.sebabTidakSekolah;
           
  
          this.getData();//dapatkan data based on HID
      },
      data: () => ({
  
          dataJRA: [],
  
          butangSimpan: true,
          butangSeterusnya: false,
          dialog: false,
          successDialog: false,
          errorDialog: false,
          psErrors: [],
          ptErrors: [],
          sjErrors: [],
          stsErrors: [],
          successMessage:'',
          errMessage:'',
          message: "Saving Data",
          popUpALert:false,
          search: '',
          
          masco: [],
          msic: [],
          lookupbulan:[],
          hubunganIsiRumah: [],
          Jantina:[],
          kumpulanEtnik:[],
          kewarganegaraan:[],
          residen:[],
          tarafPerkahwinan:[],
          jenisKetidakupayaan:[],
          pendaftaranOKU:[],
          persekolahan:[],
          sebabTidakSekolah:[],
          tarafPendidikanTertinggi:[],
          sijilTertinggi:[],
          tarafAktiviti:[],
          kesanCovidTerhadapPekerjaan:[],
          kesanCovidTerhadapPendapatan:[],
          yaTidak:[],
          lookupS19i:[],
          
          currNOAIRData: '',
          showS7: true,
          showS8: true,
          showS11:false,
          showS13:false,
          showS17:false,
          showS18:false,
          showS19i: false,
          butangKemaskini: false,
          S20:'',
          NOIC:'',
  
          /////////////////////data declaration//////////////////////////
          HID: '',
          KAW: 1,
          Bulan:'',
          Tahun:'',
          BNO:'',
          Ps:'',
          S:'',
          NG: '',
          DP:'',
          DB:'',
          BP:'',
          ST:'',
          NOTK:'',
          NOIR:'',
          R:'',
  
          Nama:'',
          PKIR:'',
          PK:'',
          PN:'',
          J:'',
          TK:'',
          U:'',
          BTK:'',
          KET:'',
          KW:'',
          RS:'',
          TP:'',
          OKU:'',
          POKU:'',
          PS:'',
          STS: '',
          PT:'',
          SJ:'',
          TA:'',
          TAnyatakan:'',
          // KC:{"id":"0"},
          // PC:{"id":"0"},
          PP:'',
          KL:'',
          S19i: '',
          NOAIR:'',
          M:'',
          OKUP:'',
          rules: [
          value => !!value || 'Required.',
        ],
          headers: [
            {
              text: 'HID',
              align: 'start',
              sortable: false,
              value: 'HID',
            },
            { text: 'NOAIR', value: 'NOAIR' },
            { text: 'PKIR', value: 'PKIR' },
            { text: 'Jantina', value: 'J' },
            { text: 'Tahun Kelahiran', value: 'TK' },
            { text: 'Umur', value: 'U' },
            { text: 'Bulan Tahun Kelahiran', value: 'BTK' },
            { text: 'Kumpulan Entnik', value: 'KET' },
            { text: 'Kewarganegaraan', value: 'KW' },
            { text: 'NOIC', value: 'NOIC' },
            { text: 'Residen', value: 'RES' },
            { text: 'Taraf Perkahwinan', value: 'TP' },
            { text: 'OKU', value: 'OKU' },
            { text: 'OKUP', value: 'OKUP' },
            { text: 'Pendaftaran OKU', value: 'POKU' },
            { text: 'Persekolahan', value: 'Ps' },
            { text: 'Sebab Tidak Bersekolah', value: 'STS' },
            { text: 'Taraf Pendidikan Tertinggi', value: 'PT' },
            { text: 'Sijil Tertinggi diperoleh', value: 'SJ' },
            { text: 'Taraf Aktiviti', value: 'TA' },
            { text: 'Taraf Aktiviti Lain-lain', value: 'TAnyatakan' },
            { text: 'PK', value: 'PK' },
            { text: 'PN', value: 'PN' },
            { text: 'M', value: 'M' },
            // { text: 'Kesan Dengan Covid terhadap Pekerjaan', value: 'KC' },
            // { text: 'Kesan Dengan Covid terhadap Pekerjaan Pendapatan', value: 'PC' },
            { text: 'PP', value: 'PP' },
            { text: 'Bil. Pekerjaan', value: 'S19i' },
            { text: 'Bantuan', value: 'S20' },
          ],
         ///////////link untuk ke page/////////////////////
        breadcrumbs: [
          {
            text: 'Status Pengisian',
            disabled: false,
            href: 'ringkasanMaklumatIR',
          },
          {
            text: 'JRA',
            disabled: true,
            href: 'JRC',
          },
        ],
        valid: true,
        name: '',
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        select: null,
        checkbox: false,
      }),
  
      methods: {
  
        validate () {
          this.$refs.form.validate()
        },
        reset () {
          this.$refs.form.reset()
        },
        resetValidation () {
          this.$refs.form.resetValidation()
        },
        async simpan (){
                 
          await this.semakan();
  
          if (this.stsErrors.length <= 0 && this.psErrors.length <= 0 && this.ptErrors.length <= 0 && this.sjErrors.length <= 0){
  
              try {
  
                  const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR/JRA`, {
                  HID:  this.HID,
                  NOAIR:  this.NOAIR,
                  Nama: this.Nama,
                  PKIR: this.PKIR,
                  J: this.J.id,
                  TK: this.TK,
                  U: this.U,
                  BTK: this.BTK,
                  KET: this.KET.kodEtnik,
                  KW: this.KW.id,
                  RS: this.RS.id,
                  TP: this.TP.id,
                  OKU: this.OKU.id,
                  OKUP: this.OKUP,
                  POKU: this.POKU.id,
                  PS: this.PS.id,
                  STS: this.STS.id,
                  PT: this.PT.kodPendidikan,
                  SJ: this.SJ.kodSijil,
                  TA: this.TA.kod_aktiviti,
                  TAnyatakan: this.TAnyatakan,
                  // KC: this.KC.id,
                  // PC: this.PC.id,
                  PP: this.PP.id,
                  S19i: this.S19i.id,
                  S20: this.S20.id,
                  NOIC: this.NOIC,
                  PK: this.PK.kod,
                  PN: this.PN.kod,
                  M: this.M.id
                })
                  this.res = res.data;
                  this.reset();
                  this.getData();
                  
                  this.successMessage = 'Data Disimpan!';
                  this.successDialog = true; 
                  
              } catch (error) {
                //console.log(error)
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'Simpan : '+error;
              }
          }
        },
        async padam(val){
          if(val == 0){
            this.popUpALert = true; 
          }
          else if(val == 1){
            
            try {
                ///////////tunjukkan alert padam////////////
                this.popUpALert = false;
                  ////send delete to API///////
                if (this.$refs.form.validate()){
                  const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK1/delete`, {
                  HID:  this.HID,
                  NOAIR: this.NOAIR,
                })
                  this.res = res.data
                  this.successDialog = true;
                  setTimeout(() => (this.successDialog = false), 2000);
                  this.successMessage = 'Data Deleted!'
                  this.saveButton = false;
                  this.updateButton = true;
                  this.reset();
                  this.getData(); 
                }else{
                  this.errorDialog = true;
                  setTimeout(() => (this.errorDialog = false), 2000);
                  this.errMessage = "Please Fill In the field"
                }
                
              } catch (error) {
                //console.log(error)
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'Padam : '+error;
              }
          }
          else if(val == 2){
            this.popUpALert = false;
          }
            
        },
        async getData(){
          //dapatkan data dari table HK1 based on HID
          try {
              const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR/JRA?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
              })
              var dataz = res.data.data
              this.dataJRA = dataz;
  
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'getData : '+ error;
            }
        },
        handleClick(row) {
            this.butangKemaskini = true;
            this.successMessage = 'Data Pengisian Dipilih, Nyatakan pilihan anda!';
            this.successDialog = true;
            // this.PP = row.PP;
            // this.S20 = row.S20;
            
            this.J = this.Jantina[Number(row.J) - 1];
            this.TK =  row.TK;
            this.U = row.U;
            this.BTK = row.BTK;
            this.NOIC = row.NOIC;
            this.TP = this.tarafPerkahwinan[Number(row.TP) - 1];
            this.OKU = this.jenisKetidakupayaan[Number(row.OKU) - 1];
            this.OKUP = row.OKUP;
            this.POKU = this.pendaftaranOKU[Number(row.POKU) - 1];
            this.PS = this.persekolahan[Number(row.Ps) - 1];
            this.M = this.lookupbulan[Number(row.M) - 1];
            this.TAnyatakan = row.TAnyatakan;

  
            if(row.KW == 2){
              this.RS = this.residen[Number(row.RES) - 1];
            }else{
              this.RS = {id:0};
            }

            if(row.STS != 0){
              this.STS = this.sebabTidakSekolah[Number(row.STS) - 1];
            }else{
              this.STS = this.sebabTidakSekolah[7];
            }
            
            
            for(var i = 0; i<this.tarafAktiviti.length;i++){
                if(row.TA == this.tarafAktiviti[i].kod_aktiviti){
                  this.TA = this.tarafAktiviti[i];
                }
              }
            
            var indexTA = Number(row.TA) - 1;
            
            if(indexTA < 7){
              for(i = 0; i<this.kesanCovidTerhadapPekerjaan.length;i++){
                if(row.KC == this.kesanCovidTerhadapPekerjaan[i].id){
                  this.KC = this.kesanCovidTerhadapPekerjaan[i];
                }
              }
  
              for(i = 0; i<this.kesanCovidTerhadapPendapatan.length;i++){
                if(row.PC == this.kesanCovidTerhadapPendapatan[i].id){
                  this.PC = this.kesanCovidTerhadapPendapatan[i];
                }
              }
  
            }
            
            this.PP = this.yaTidak[Number(row.PP) - 1];
            
            if(row.PP == 1){
              this.S19i = this.lookupS19i[row.S19i];
            }
            
            this.S20 = this.yaTidak[Number(row.S20) - 1];
  
  
            for(i=0;i<this.kumpulanEtnik.length;i++){
              if(row.KET == this.kumpulanEtnik[i].kodEtnik){
                this.KET = this.kumpulanEtnik[i];
              }
            }
  
            for(i=0;i<this.kewarganegaraan.length;i++){
              if(row.KW == this.kewarganegaraan[i].id){
                this.KW = this.kewarganegaraan[i];
              }
            }
  
            for(i=0;i<this.tarafPendidikanTertinggi.length;i++){
              if(row.PT == this.tarafPendidikanTertinggi[i].kodPendidikan){
                this.PT = this.tarafPendidikanTertinggi[i];
              }
            }
  
            for(i=0;i<this.sijilTertinggi.length;i++){
              if(row.SJ == this.sijilTertinggi[i].kodSijil){
                this.SJ = this.sijilTertinggi[i];
              }
            }
  
            for(var a=0;a<this.masco.length;a++){
              if(row.PK == this.masco[a].kod){
                this.PK = this.masco[a];
              }
            }
  
            for(var b=0;i<this.msic.length;b++){
              if(row.PN == this.msic[b].kod){
                this.PN = this.msic[b];
              }
            }
           
            
        },
        goTo(option){
  
          if(option == "1"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
  
          if(option == "2"){
        
            if(this.dataJRA[0].PP == 2 && this.dataJRA[0].S20 == 1){
              this.$router.push({name: "JRB1off"});
            }
            if(this.dataJRA[0].PP  == 1 && this.dataJRA[0].S20 == 1){
              this.$router.push({name: "JRB"});
            }
            if(this.dataJRA[0].PP  == 1 && this.dataJRA[0].S20 == 2){
              this.$router.push({name: "JRB"});
            }
            if(this.dataJRA[0].PP  == 2 && this.dataJRA[0].S20 == 2){
              this.$router.push({name: "ringkasanMaklumatIR"});
            }
          }   
        },
        semakan(){
          this.psErrors = [];
          this.ptErrors = [];
          this.sjErrors = [];
          this.stsErrors = [];
          
          if(this.PS.id == 1){
  
             if(this.U <3){
              if(this.PT.kodPendidikan == '001'){
                 this.ptErrors = [];
              }else{
                this.ptErrors = ["Pilihan tidak tepat sila semak kembali PT. PT haruslah 001"]
              if(this.SJ.kodSijil == '020'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020"]
                }
              }
             }
  
             if(this.U >=3 && this.U <=6){
              if(this.PT.kodPendidikan == '002'){
                 this.ptErrors = [];
              }else{
                this.ptErrors = ["Pilihan tidak tepat sila semak kembali PT. PT haruslah 002"]
              if(this.SJ.kodSijil == '020'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020"]
                }
              }
             }
  
            if(this.PT.kodPendidikan >= '001' && this.PT.kodPendidikan <= '002'){
              if(this.SJ.kodSijil == '020'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020"]
              }
            }
  
             if(this.PT.kodPendidikan >= '004' && this.PT.kodPendidikan <= '005'){
              if(this.SJ.kodSijil == '020'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020"]
              }
            }
  
                if(this.U >=7 && this.U <=12 || this.U>=13){
                if(this.PT.kodPendidikan >= '101' && this.PT.kodPendidikan <= '106'){
              if(this.SJ.kodSijil == '020' || this.SJ.kodSijil == '101'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 atau 101"]
                }
                }
              }
             
              if(this.U >=13 && this.U <=16 || this.U>=17){
             if(this.PT.kodPendidikan >= '201' && this.PT.kodPendidikan <= '204'){
              if(this.SJ.kodSijil == '020' || this.SJ.kodSijil == '101' || this.SJ.kodSijil == '102'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 , 101 atau 102"]
              }
            }
          }
  
             if(this.U >=16 && this.U <=18 || this.U>=19){
            if(this.PT.kodPendidikan >= '205' && this.PT.kodPendidikan <= '209'){
               if((this.SJ.kodSijil == '020' || this.SJ.kodSijil >= '101' && this.SJ.kodSijil <= '102') || (this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '242')){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020, 101 - 102 atau 241 - 242"]
              }
            }
             }
  
             if(this.U >=18){
            if(this.PT.kodPendidikan >= '301' && this.PT.kodPendidikan <= '311'){
              if((this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '345') || this.SJ.kodSijil == '351' ){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 345 atau 351"]
              }
            }
  
             if(this.PT.kodPendidikan >= '401' && this.PT.kodPendidikan <= '404'){
              if(this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '352'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 241 - 352"]
              }
            }
  
            if(this.PT.kodPendidikan >= '501' && this.PT.kodPendidikan <= '504'){
               if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '357'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 357"]
              }
            }
  
            if(this.PT.kodPendidikan == '601'){
               if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '556'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 556"]
              }
            }
  
            if(this.PT.kodPendidikan >= '701' && this.PT.kodPendidikan <= '702'){
              if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '667'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 667"]
              }
            }
  
            if(this.PT.kodPendidikan >= '801' && this.PT.kodPendidikan <= '802'){
               if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '767'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 767"]
              }
            }
  
            if(this.PT.kodPendidikan == '003'){
              if(this.SJ.kodSijil >= '020' && this.SJ.kodSijil <= '862'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 - 862"]
              }
            }
            }
          }//end id  == 1
  
          if(this.PS.id == 2){
  
             if(this.U >=7 && this.U <=18){
               if(this.STS.id == '9'){
              this.stsErrors = [];
                }else{
                this.stsErrors = ["Pilihan tidak tepat sila semak kembali STS. STS haruslah 9"]
              }
            }
  
            if(this.PT.kodPendidikan >= '306' && this.PT.kodPendidikan <= '311'){
                if((this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '345') || this.SJ.kodSijil == '351'){
                this.sjErrors = [];
                }else{
                  this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 345 atau 351"]
                }
              }
            
            if(this.PT.kodPendidikan >= '401' && this.PT.kodPendidikan <= '404'){
               if(this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '352'){
                this.sjErrors = [];
                }else{
                  this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 241 - 352"]
                }
              }
            
             if(this.PT.kodPendidikan >= '501' && this.PT.kodPendidikan <= '504'){
                if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '357'){
                this.sjErrors = [];
                }else{
                  this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 357"]
                }
              }   
            
            if(this.PT.kodPendidikan == '601'){
                if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '556'){
                this.sjErrors = [];
                }else{
                  this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 556"]
                }
              }
            
            if(this.PT.kodPendidikan >= '701' && this.PT.kodPendidikan <= '702'){
                if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '667'){
                this.sjErrors = [];
                }else{
                  this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 667"]
                }
              }
            
            if(this.PT.kodPendidikan >= '801' && this.PT.kodPendidikan <= '802'){
                if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '767'){
                this.sjErrors = [];
                }else{  
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 767"]
                }
              }
            
             if(this.PT.kodPendidikan == '003'){
              if(this.SJ.kodSijil >= '020' && this.SJ.kodSijil <= '862'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 - 862"]
              }
            }
          }//end id  == 2
  
          if(this.PS.id == 3){
  
            if(this.U >=7 && this.U <=18){
               if(this.STS.id >= '1' && this.STS.id <= '9'){
              this.stsErrors = [];
                }else{
                this.stsErrors = ["Pilihan tidak tepat sila semak kembali STS. STS haruslah 1 - 9"]
              }
            }
  
            if(this.PT.kodPendidikan >= '101' && this.PT.kodPendidikan <= '106'){
              if(this.SJ.kodSijil == '020' || this.SJ.kodSijil >= '101' && this.SJ.kodSijil <= '102'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 , 101 atau 102"]
              }
            }
            
            if(this.PT.kodPendidikan >= '201' && this.PT.kodPendidikan <= '204'){
              if(this.SJ.kodSijil == '020' || (this.SJ.kodSijil >= '101' && this.SJ.kodSijil <= '102') || (this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '242')){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 , 101 - 102 atau 241 - 242"]
              }
            }
            
            if(this.PT.kodPendidikan >= '205' && this.PT.kodPendidikan <= '209'){
              if(this.SJ.kodSijil  >= '101' && this.SJ.kodSijil <= '102' || (this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '242') ||(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '351')){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 101 - 102 , 241 - 242 atau 341 - 351"]
              }
            }
  
            if(this.PT.kodPendidikan >= '301' && this.PT.kodPendidikan <= '311'){
              if((this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '349') || this.SJ.kodSijil == '351'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 349 atau 351"]
              }
            }
            
            if(this.PT.kodPendidikan >= '401' && this.PT.kodPendidikan <= '404'){
              if(this.SJ.kodSijil >= '241' && this.SJ.kodSijil <= '357'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 241 - 357"]
              }
            }
            
            if(this.PT.kodPendidikan >= '501' && this.PT.kodPendidikan <= '504'){
              if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '556'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 556"]
              }
            }
            
            if(this.PT.kodPendidikan == '601'){
              if(this.SJ.kodSijil >= '341' && this.SJ.kodSijil <= '667'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 341 - 667"]
              }
            }
            
            if(this.PT.kodPendidikan >= '701' && this.PT.kodPendidikan <= '702'){
              if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '767'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 767"]
              }
            }
  
            if(this.PT.kodPendidikan >= '801' && this.PT.kodPendidikan <= '802'){
              if(this.SJ.kodSijil >= '551' && this.SJ.kodSijil <= '862'){
                this.sjErrors = [];
                }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah antara 551 - 862"]
              }
            }
  
            if(this.PT.kodPendidikan == '003'){
              if(this.SJ.kodSijil >= '020' && this.SJ.kodSijil <= '862'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020 - 862"]
              }
            }
          }//end id  == 3
  
           if(this.PS.id == 4){
  
            if(this.U >=7 && this.U <=18){
               if(this.STS.id >= '1' && this.STS.id <= '9'){
              this.stsErrors = [];
                }else{
                this.stsErrors = ["Pilihan tidak tepat sila semak kembali STS. STS haruslah 1 - 9"]
                if(this.U <=9){
                if(this.PT.kodPendidikan == '005'){
                 this.ptErrors = [];
              }else{
                this.ptErrors = ["Pilihan tidak tepat sila semak kembali PT. PT haruslah 005"]
              if(this.SJ.kodSijil == '020'){
                this.sjErrors = [];
              }else{
                this.sjErrors = ["Pilihan tidak tepat sila semak kembali SJ. SJ haruslah 020"]
                }
               }
              }
            }
          }
        } //end id  == 4
      }, //end semakan
      checkMandatori(){
          if(!this.Nama || !this.PKIR || !this.J || !this.U || !this.KET || !this.KW || !this.TP || !this.OKU || !this.PS || !this.PT || !this.SJ || !this.TA || !this.PP ||  !this.S19i || !this.S20 || !this.PK || !this.PN){
            return true
          }else{
            return false;
          }
        }
    },




      watch:{
        TK(tahunKelahiran){
          var currYear = new Date().getFullYear();
          var age = Number(currYear) - Number(tahunKelahiran);

          if(age == 0){
            this.U = '00';
          }
          else if(age > 98){
            this.U = 98;
          }
          else{
            this.U = age;
          }

        },


        OKU(val){ 
       { if(val.id >= 1 || val.id <=6){
          this.showS11 = true;
        }

        if (val.id == 8){
          this.showS11 = false;
          this.POKU = this.pendaftaranOKU[2];
        }
      }

     { if(val.id == 7){
          this.showS10 = true;
        }
        else {
          this.showS10 = false;
          this.OKUP = 0;}
        }
    },

    TA(val){ 
      if(val.kod_aktiviti == 19){
          this.showS16 = true;
        }
        else {
          this.showS16 = false;
          this.TAnyatakan = 0;}
    },
    
        PS(val){
            this.psErrors = [];
            this.showS13 = false;
            if(this.U >=7 && this.U <=18){
              if(val.id >=2){
                this.showS13 = true;
              
              }
            }
            // if(val.id == 4){
            //   var ptList = ["003","004","005"];
            //   this.SJ = this.sijilTertinggi[0];
              
            //   for(var i=0; i< this.tarafPendidikanTertinggi.length; i++){
            //     this.tarafPendidikanTertinggi[i]["disabled"] = true;
            //     for(var x=0; x < ptList.length; x++){
            //       if(this.tarafPendidikanTertinggi[i].kodPendidikan == ptList[x] ){
            //         this.tarafPendidikanTertinggi[i]["disabled"] = false;
            //       }
            //     }
            //   }
              
            // }
        },
        PT(){
          this.ptErrors = [];
        },
        STS(){
          this.stsErrors = [];
        },
        SJ(){
          this.sjErrors = [];
        },
         //TA(val){
       //   this.showS17=false;
        //  this.showS18=false; 
  
          //console.log(val.kod_aktiviti)
  
          //if(val.kod_aktiviti >=1 && val.kod_aktiviti <= 7){
         //   this.showS17=true;
      //      this.showS18=true;
       //   }else{
        //    this.showS17=false;
         //   this.showS18=false;
  
          //  this.KC = {"id":0};
          //  this.PC = {"id":0};
  
        //  }
       // }, 
        KW(val){
          if(val.id == 1){
            this.showS7 = true;
            this.showS8 = false;
            this.RS = { id:0 };
          }else{
            this.showS7 = false;
            this.showS8 = true;
            this.NOIC = 0;
          }
        },
        U(val){
          if(val <= 10){
            this.TP = this.tarafPerkahwinan[0];
          }
        },
  
        PP(val){
          if(val.id == 1){
            this.showS19i = true;
          }else{
            this.showS19i = false;
          }
        }
        // dataJRA(){
        //   if(this.dataJRA.length > 0){
        //     this.butangSimpan = false;
        //   }
        // }
      },
  
  }
  </script>
  
  <style>
  #app {
    background: url('~@/assets/HIES.jpg')
    no-repeat center center fixed !important;
    background-size: cover;
  }
  
  </style>